<template>
  <t-default-entry
    v-show="finishCheckAuthen"
    sub-heading="Login"
    heading="ログイン"
    :navigation-items="navigationItems"
  >
    <section class="t-entry__col">
      <div class="t-entry__form-wrapper">
        <div class="t-entry__body">
          <div v-if="error" class="t-login__alert">
            <a-alert :title="errorMessage" color="error" size="small" />
          </div>
          <form class="t-login__form">
            <div class="t-login__group">
              <m-form-input label="契約ID">
                <a-select-field
                  v-model="companyID"
                  :options="validCompanyList"
                  :disabled="isDisabled || validCompanyList.length === 0"
                />
              </m-form-input>
            </div>
            <m-button-container class="t-login__buttons">
              <a-button
                variant="block"
                color="primary"
                :disabled="isDisabled || validCompanyList.length === 0"
                @click="processLogin()"
                >ログイン</a-button
              >
            </m-button-container>
          </form>
        </div>
      </div>
    </section>
  </t-default-entry>
</template>

<script>
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
// import ACaptionList from '@/components/atoms/caption-list';
// import ACheckbox from '@/components/atoms/checkbox';
// import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

export default {
  name: 't-login',
  components: {
    AAlert,
    AButton,
    // ACaptionList,
    // ACheckbox,
    // ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
  },
  mixins: [customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
  },
  data: function () {
    return {
      email: '',
      signature: '',
      companyID: '',
      validCompanyList: [],
      error: false,
      errorMessage: '',
      isDisabled: false,
      finishCheckAuthen: false,
    };
  },
  created: function () {
    this.postRequest('/sessioncheck')
      .then(res => {
        if (res.session) {
          if (res.tempPwdFlag) {
            this.$router.push({ name: 'LoginInvitedUserSetPassword' });
          } else if (res.firstVisitFlag && res.authInfo !== 'operator' && res.authInfo !== 'オペレーター') {
            //TODO: remove english key later
            this.$router.push({ name: 'WTInviteUser' });
          } else {
            this.$router.push({ name: 'Home' });
          }
        } else {
          this.finishCheckAuthen = true;
        }
      })
      .catch(err => {
        this.finishCheckAuthen = true;
        console.log(err);
        this.error = true;
        this.errorMessage = messageContent.requireTry('検索');
      });
  },
  mounted: function () {
    this.checkLogin();
  },
  methods: {
    processLogin: function () {
      if (!this.companyID) {
        this.error = true;
        this.errorMessage = messageContent.requireChoice('契約ID');
      } else {
        this.error = false;
        this.errorMessage = '';
        this.checkLogin();
      }
    },
    checkLogin: function () {
      this.error = false;
      this.isDisabled = true; // Disable login button
      const dAuthData = {
        email: this.email,
        signature: this.signature,
        code: this.$route.query.code || 'dummy', // ローカルでdebugの場合、dummyになります
        state: this.$route.query.state || 'dummy', // ローカルでdebugの場合、dummyになります
        companyID: this.companyID,
        redirect_uri: this.$route.query.redirect_uri,
      };
      this.postRequest('/dauth', dAuthData)
        .then(res => {
          this.isDisabled = false; // Enable login button
          if (res.session) {
            this.setCookie('notifyMessageDisplayFlag', 'ON'); // #3005
            if (res.data.firstVisitFlag && res.data.authInfo === 'supervisor') {
              // マスタ管理者が初めてアクセス場合、ウォークスルーページに移動します
              window.location.href = '/walk-through/invite-user';
            } else {
              // 普通にホームページに移動します
              window.location.href = '/home';
            }
          } else if (res.status === 'success') {
            this.email = res.email;
            this.signature = res.signature;
            this.validCompanyList = [];
            for (const companyID of res.data) {
              this.validCompanyList.push({ label: companyID, value: companyID });
            }
            this.companyID = res.data[0];
          } else {
            this.error = true;
            this.errorMessage = messageContent.dauthLoginError;
            this.goToLoginPage();
          }
        })
        .catch(err => {
          this.isDisabled = false; // Enable login button
          console.log(err);
          this.error = true;
          this.errorMessage = messageContent.requireTry('検索');
        });
    },
    goToLoginPage() {
      const that = this;
      setTimeout(() => {
        that.$router.push({ name: 'login' });
      }, 5000);
    },
    // #3005
    setCookie(key, value, expires = null) {
      if (!expires) {
        const d = new Date();
        // Cookie expires after 3 days
        d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
        expires = 'expires=' + d.toUTCString();
      }
      document.cookie = `${key}=${value};expires=${expires}`;
    },
  },
};
</script>
